import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

const DEFAULT_SIZE = 36

const StyledProfileIcon = styled.a`
    cursor: ${props => (props.onClick ? 'pointer' : '')};
    align-items: center;

    img {
        display: inline-block;
        width: ${props => props.size}px;
    }
`

const ProfileIcon = ({ src, size = DEFAULT_SIZE, ...props }) => {
    const [name, setName] = useState('')

    useEffect(() => {
        const token = JSON.parse(window.localStorage.getItem('claims'))
        const name = token ? token.first_name + ' ' + token.last_name : ''
        setName(name)
    }, [])

    return (
        <StyledProfileIcon size={size} {...props}>
            <img
                className="!mr-4"
                src={`https://eu.ui-avatars.com/api/?name=${name}&background=338ce4&color=fff&rounded=true`}
            />
            {name}
        </StyledProfileIcon>
    )
}

export default ProfileIcon
